// Mixin para manejo automático de empresa en formularios
export const empresaMixin = {
  created() {
    // Capturar la empresa seleccionada automáticamente
    this.captureSelectedEmpresa();
  },
  methods: {
    captureSelectedEmpresa() {
      // Capturar la empresa seleccionada del localStorage
      const empresaSeleccionada = JSON.parse(localStorage.getItem('empresa_seleccionada') || 'null');
      if (empresaSeleccionada && empresaSeleccionada.EmpresaId) {
        this.formData.EmpresaId = empresaSeleccionada.EmpresaId;
      }
    },
    
    // Método para asegurar que la empresa esté capturada antes de enviar
    ensureEmpresaCaptured() {
      this.captureSelectedEmpresa();
    }
  }
};

export default empresaMixin;
